/**
 * Attachment limits shared by the post-creation panel
 * (DiscussionAttachments) and the creation wizard's staging panel
 * (StagedAttachments).
 *
 * Both must match DiscussionAttachmentsService.MaxFileSizeBytes /
 * AllowedContentTypes on the backend — the server rejects anything
 * outside these, so validating client-side is purely so the user finds
 * out before the upload round-trip rather than after.
 */

export const MAX_FILE_SIZE_BYTES = 5_000_000;

// Images only — the click-to-view flow renders these inline via a Fluent
// Dialog and has no path for anything else.
export const ALLOWED_CONTENT_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/gif",
  "image/webp",
];

/**
 * Returns a user-facing reason the file can't be attached, or null when
 * it's acceptable. Message wording is shared so the wizard and the
 * post-creation panel report the same thing for the same file.
 */
export function validateAttachmentFile(file: File): string | null {
  if (!ALLOWED_CONTENT_TYPES.includes(file.type)) {
    return `"${file.name}" is not a supported file type. Attach an image (PNG, JPG, GIF, or WEBP).`;
  }
  if (file.size > MAX_FILE_SIZE_BYTES) {
    return `"${file.name}" is larger than ${MAX_FILE_SIZE_BYTES / 1_000_000}MB.`;
  }
  return null;
}
